import { Input, message } from "antd"
import { ReactComponent as AddSvg } from "../icons/add.svg"
import { ReactComponent as DeleteSvg } from "../icons/delete.svg"
import "./summary-detail.less"
import { MeetingSummary } from "@/declare/interface/meeting"
import { useEffect, useState } from "react"
import { deleteMeetingSummary, updateMeetingSummary } from "@/declare/api/meeting"
import TextArea from "antd/es/input/TextArea"

interface IProps {
    summaryList: MeetingSummary[]
    onClickAdd: () => void
    onClickDelete: (id: number) => void
}


export default function MeetingMinuteSummaryDetail(props: IProps) {

    const { summaryList, onClickAdd, onClickDelete } = props

    const [pageList, setPageList] = useState<MeetingSummary[]>([])

    useEffect(() => {
        setPageList(summaryList || [])
    }, [summaryList])

    /**
     * 修改总结条目信息
     * @param index 
     * @param key 
     * @param value 
     */
    const onChangeSummaryValue = (index: number, key: string, value: any) => {
        pageList[index][key] = value
        setPageList([...pageList])
        let updateData: MeetingSummary = {}
        updateData[key] = value
        updateMeetingSummary(pageList[index].id, updateData).catch(e => {
            message.error("更新失败")
        })
    }
    return (
        <div className="record-summary-detail-main">
            <div className="add-area" onClick={() => { onClickAdd() }}>
                <AddSvg style={{ height: 24, width: 24 }} />
                新增关键词条目
            </div>
            <div className="summary-list">
                {pageList?.map((summary, index) => (
                    <div className="summary-item" key={index}>
                        <div className="key-word">
                            {/* AI总结关键词 */}
                            <Input
                                variant="borderless"
                                value={summary.keyWord}
                                onChange={(e) => { onChangeSummaryValue(index, "keyWord", e.target.value) }}
                            />
                        </div>
                        <div className="item-detail">
                            <TextArea
                                autoSize
                                value={summary.content}
                                onChange={(e) => { onChangeSummaryValue(index, "content", e.target.value) }}
                            />
                            <DeleteSvg onClick={() => { onClickDelete(summary.id) }} className="delete-icon" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}